import { avatarSizes } from 'constants/avatar'

export const memberList = {
  avatarMargin: 8,
  avatarSize: avatarSizes.tiny,
}
